<template>
    <b-container class="m-3">
        <b-row class="p-1">
            <b-img left src="https://i.imgur.com/8UMZlcj.png" height="50"></b-img>
        </b-row>
        <b-row class="p-1">
            <b-col>
                <b-row>
                    <p class="h5">
                        <strong>Is this your business?</strong>
                    </p>
                </b-row>
                <b-row>Claim your business to immediately update business information, respond to reviews, and more!</b-row>
            </b-col>
        </b-row>
        <b-row class="p-1">
            <b-button variant="outline-primary">Claim This Business</b-button>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    
}
</script>